import { DotLoader } from 'react-spinners';

import { useTheme } from '@emotion/react';

import { styled } from '../theme';

type Props = {
    backdrop?: boolean;
    centered?: boolean;
    size?: 'small' | 'default';
    color?: string;
};

const Container = styled('div')<Props>(({ theme, backdrop, centered }) => ({
    display: 'flex',
    justifyContent: 'center',
    ...(backdrop && {
        backgroundColor: theme.color.backdropBackground,
    }),

    ...(centered
        ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              alignItems: 'center',
          }
        : {
              marginTop: 45,
              paddingRight: 30,
          }),
}));

const Loading = ({ backdrop, centered, size = 'default', color, ...props }: Props) => {
    const theme = useTheme();
    return (
        <Container backdrop={backdrop} centered={centered ?? backdrop} color={color} {...props}>
            <DotLoader color={color ?? theme.color.surface} size={size === 'default' ? 60 : 30} />
        </Container>
    );
};

export default Loading;
